<ion-content class="ion-padding">
  <logo></logo>
  <language-switcher></language-switcher>
  <form *ngIf="loginFormGroup" [formGroup]="loginFormGroup">
    <ion-item class="input-field">
      <ion-input [clearInput]="true" data-cy="email"
                 [errorText]="usernameContainsEmail() ? ('login-page.no-email-allowed' | translate) : ''" fill="outline"
                 labelPlacement="floating" type="text" [label]="'login-page.username' | translate"
                 [formControl]="username"></ion-input>
    </ion-item>
    <ion-item class="input-field">
      <ion-input [clearInput]="true" data-cy="password" fill="outline" labelPlacement="floating" type="password"
                 [label]="'login-page.password' | translate" [formControl]="password"></ion-input>
    </ion-item>
    <ion-item>
      <ion-button slot="start" (click)="loginAsGuest()" color="secondary" fill="clear" data-cy="login-as-guest"
                  size="small">{{ 'login-page.login-as-guest' | translate }}</ion-button>
      <ion-button slot="end" (click)="onLogin()" [disabled]="!isValid()" color="primary" data-cy="login"
                  size="large">{{ 'login-page.login' | translate }}</ion-button>
    </ion-item>
    <ion-item *ngIf="isNotProd()">
      <ion-button (click)="onTestUser()" fill="clear">
        <ion-icon name="beer" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-item>

  </form>
</ion-content>
<ion-footer>
  <ion-toolbar color="darkGrey">
    <ion-buttons slot="start">
      <ion-button [routerLink]="'/signup'" color="secondary" routerDirection="root" data-cy="register"
                  size="large">{{ 'login-page.register' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button [routerLink]="'/reset-password'" color="secondary" fill="clear" routerDirection="root" size="small"
                  data-cy="forgot-password">
        {{ 'login-page.forgot-password' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
